import React from 'react';
import { Icon, IconButton, ListItemSecondaryAction, ListItemText, Typography, } from '@material-ui/core';
const rate = (data, arrayAux) => {
  if (arrayAux.tarifas) {
    let sumatoria = 0.00
    for (let i = 0; i < arrayAux.tarifas.length; i++) {
      if (arrayAux.nro_ticket > data.tar_cant) {
      }
      if (arrayAux.tarifas[i].tar_id === data.tar_id) {
        arrayAux.tarifas[i].tar_cant = data.tar_cant
        sumatoria = sumatoria + (data.tar_cant * arrayAux.tarifas[i].tar_valor)
      } else {
        sumatoria = sumatoria + (arrayAux.tarifas[i].tar_cant * arrayAux.tarifas[i].tar_valor)
      }
    }
    arrayAux.total = sumatoria.toFixed(2)
  }
  else {
    arrayAux.total = 0.00
  }
  return arrayAux
}
const rate2 = (data, arrayAux) => {
  let sumatoria = 0.00
  if (arrayAux.tarifas) {
    for (let i = 0; i < arrayAux.tarifas.length; i++) {
      if (arrayAux.nro_ticket > data.tar_cant) {
      }
      if (arrayAux.tarifas[i].tar_id === data.tar_id) {
        arrayAux.tarifas[i].tar_cant = data.tar_cant
        sumatoria = sumatoria + data.tar_cant
      } else {
        sumatoria = sumatoria + arrayAux.tarifas[i].tar_cant
      }
    }
    // arrayAux.total = sumatoria.toFixed(2)
  }
  else {
    sumatoria = 0.00
  }
  return sumatoria
}
const RenderSelectFieldTranvia = props => {
  const { data, handleParameterRateCount, arrayAux, setTotal } = props
  const [count, setCount] = React.useState(0);
  return <div><ListItemText style={{ paddingLeft: 10 }}
    primary={<Typography >{data.tar_descripcion}</Typography>}
    secondary={
      <React.Fragment>
        <Typography
          component="span"
          variant="body2"
          color="textPrimary"
        >
          {data.tar_valor}
        </Typography>
      </React.Fragment>
    }
  />
    <ListItemSecondaryAction>
      <IconButton style={{ margin: 0, padding: 10 }} edge="end" aria-label="delete" onClick={() => {
        if (data.tar_cant >= arrayAux.nro_ticket) {
        }
        if (rate2(data, arrayAux) >= arrayAux.nro_ticket) {
        }
        else {
          data.tar_cant = data.tar_cant + 1
          setCount(data.tar_cant)
          handleParameterRateCount(rate(data, arrayAux))
          setTotal(rate(data, arrayAux))
        }
      }} >
        <Icon>add</Icon>
      </IconButton>
      <React.Fragment>
        <Typography
          component="span"
          variant="body2"
          color="textPrimary"
        >
          {count}
        </Typography>
      </React.Fragment>
      <IconButton style={{ margin: 0, padding: 10 }} edge="end" aria-label="delete" onClick={() => {
        if (data.tar_cant <= 0) {
          data.tar_cant = 0
        }
        else {
          data.tar_cant = data.tar_cant - 1
          setCount(data.tar_cant)
          handleParameterRateCount(rate(data, arrayAux))
          setTotal(rate(data, arrayAux))
        }
      }} >
        <Icon>remove</Icon>
      </IconButton>
    </ListItemSecondaryAction></div>
}
export default RenderSelectFieldTranvia;